import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { isRejected } from '@reduxjs/toolkit'
import { ContractorFormValues } from 'shared/types'
import { actions } from 'shared/store'
import { SERVER_ERROR_DIALOG_PAYLOAD } from 'shared/services/Api/Api.constants'
import { getAddContractorDialogState } from 'shared/store/contractors/selectors'
import { MODULE_NAME } from 'modules/Contractors/strings'

export const useErrorDialogContent = () => {
  const { t } = useTranslation(MODULE_NAME)
  const dialogContent = {
    ...SERVER_ERROR_DIALOG_PAYLOAD,
    title: t('contractor.errorDialog.title'),
    text: t('contractor.errorDialog.description'),
  }

  return dialogContent
}

export const useAddContractor = ({
  openSuccessDialog,
}: {
  openSuccessDialog: boolean
}) => {
  const dispatch = useDispatch()
  const errorDialogContent = useErrorDialogContent()

  const { isOpen } = useSelector(getAddContractorDialogState)

  const handleOpen = () =>
    dispatch(actions.contractors.setAddContractorDialogOpen(true))

  const handleClose = () =>
    dispatch(actions.contractors.setAddContractorDialogOpen(false))

  const onSubmit = async (data: ContractorFormValues) => {
    const {
      phoneNumber,
      phonePrefix,
      emailAddress,
      countryId,
      isContactActive,
      apartmentNumber,
      nationalBusinessRegistryNumber,
      ...contractorRequestData
    } = data
    const requestData = {
      ...contractorRequestData,
      countryId,
      openSuccessDialog,
      apartmentNumber: apartmentNumber || null,
      nationalBusinessRegistryNumber: nationalBusinessRegistryNumber || null,
      contact:
        phoneNumber || emailAddress
          ? {
              phoneNumber: phoneNumber || null,
              emailAddress: emailAddress || null,
              countryId: phonePrefix,
              isContactActive: data.isContactActive,
            }
          : null,
    }
    const response = await dispatch(
      actions.contractors.addContractor({ request: requestData })
    )
    if (isRejected(response)) {
      dispatch(actions.contractors.setAddContractorDialogOpen(false))
      dispatch(actions.ui.setDialogContent(errorDialogContent))
      dispatch(actions.ui.setDialogOpenState(true))
    }
  }

  return { isOpen, handleClose, handleOpen, onSubmit }
}
